import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from "./guards/index";
import { EditorLayoutComponent } from './layouts/editor/editor-layout.component';

export const AppRoutes: Routes = [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full'
    }, {
      path: '',
      component: AdminLayoutComponent,
      canActivate: [AuthGuard],
      children: [
          {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
    }, {
        path: 'tenants',
        loadChildren: () => import('./tenants/tenants.module').then(m => m.TenantsModule)
    }
    , {
      path: 'viewer',
      loadChildren: () => import('./viewer/viewer.module').then(m => m.ViewerModule)
    },
    {
      path: 'fillableforms',
      loadChildren: () => import('./fillableforms/fillableforms.module').then(m => m.FillableFormsModule)
    }
    ,  
    {
      path: 'reportforms',
      loadChildren: () => import('./reportforms/reportforms.module').then(m => m.ReportFormsModule)
    },
    {
      path: '',
      loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
  }, 
     {
        path: '',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
    }
    , 
     /*{
        path: 'guides',
        loadChildren: './guides/guide.module#GuideModule'
    }
    ,*/ 
    {
        path: '',
        loadChildren: () => import('./changepassword/changepassword.module').then(m => m.ChangepasswordModule)
    }
    
  ]}, {
      path: '',
      component: AuthLayoutComponent,
      children: [{
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
      }]
    },
    {
      path: '',
      component: EditorLayoutComponent,
      canActivate: [AuthGuard],
      children: [
      {
        path: 'edit',
        loadChildren: () => import('./pdfeditor/pdfeditor.module').then(m => m.PdfEditorModule)
      }]
    }
];
